export default "__VITE_ASSET__bde26260__"